import {createSvgIcon} from '../create-svg-icon';

export const BookmarkIcon = createSvgIcon(
  <path d="M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2z" />
, 'BookmarkOutlined');
